/**
 * GameSortHeader · 单游戏可排序表头
 *
 * 表头展示：游戏 cover icon + 游戏名 + 排序状态（▾/↑/↓）
 * 点击：弹出 Asc / Des / Default 三选项（参考 ValidationHeader / HoverSortCommonSimple）
 *
 * 用法（同时适用于 CountryStackedTable / CountryTable）：
 *   <GameSortHeader gameId={id} gameMap={gameMap} sortBy={sortBy} setSortBy={setSortBy} />
 */
import React from 'react';
import RenderImg from '@op/components/RenderImg';
import { DefaultImg } from '@op/constants/defaultImg';
import { TGameMap } from '../../hooks/useGameMap';
import TextBubbles from '@home/components/TextBubbles';

export interface IGameSortHeaderProps {
  gameId: string;
  gameMap: TGameMap; 
  /** 是否仅展示 icon（不显示游戏名，用于堆叠条紧凑表头） */
  iconOnly?: boolean;
}

export default function GameSortHeader({
  gameId,
  gameMap, 
  iconOnly = false,
}: IGameSortHeaderProps) { 
  const game = gameMap[gameId];
  const name = game?.game_name || gameId;

  // /** 适配 HoverSortCommonSimple 的 sort 协议 */
  // const sort = useMemo(() => {
  //   const isActive = sortBy.by_game_id === gameId;
  //   return {
  //     by: gameId,
  //     order: isActive ? sortBy.order : 'sort',
  //   };
  // }, [sortBy, gameId]);

  // const handleSortChange = (next?: { by?: string; order?: 'asc' | 'desc' }) => {

  //   if (!next?.by) {
  //     // Default Sorting：清空 sort
  //     setSortBy({
  //       by_game_id: gameId,
  //       order: 'sort',
  //     });
  //     return;
  //   }
  //   setSortBy({ by_game_id: next.by, order: next.order });
  // };

  return (
    // <HoverSortCommonSimple
    //   sort={sort}
    //   sortKey={gameId}
    //   sortChange={handleSortChange}
    //   isActive={sortBy.by_game_id === gameId}
    //   sortLabel={formatMessage('Sort By')}
    //   dropdownProps={{
    //     boxClassName: 'dbom-game-sort-header'
    //   }}
    // >
    <span
      className="dbom-game-sort-header__game-name"
      title={name}
    >
      <RenderImg
        style={{ width: 24, height: 24, borderRadius: 4, flexShrink: 0 }}
        coverImage={game?.cover || ''}
        defaultImage={DefaultImg.GAME}
        mode="image"
      />
      {!iconOnly && (
        <TextBubbles text={name} />
      )}
    </span>
    // </HoverSortCommonSimple>
  );
}
